import { isStaffArea } from './areas';

/** Standort-Label aus freigeschalteten Kennungen (nie hardcoded). */
export function tenantLabelForArea(me, area) {
  const idents = me?.identities || [];
  const match = (i) => {
    if (isStaffArea(area)) return i.person_type === 'teacher' || i.person_type === 'admin';
    if (area === 'eltern') return i.person_type === 'guardian';
    if (area === 'schueler') return i.person_type === 'student';
    return true;
  };
  const scoped = idents.filter(match);
  const names = [...new Set(
    (scoped.length ? scoped : idents)
      .map((i) => i.tenant_name)
      .filter(Boolean),
  )];
  if (names.length) return names.join(' · ');
  return null;
}

/** „Musik Akademie Greven“ → Markenzeile + Standortzeile */
export function splitTenantBrand(full) {
  const raw = (full || '').trim();
  const m = raw.match(/^Musik\s+Akademie\s+(.+)$/i);
  if (m) return { brand: 'Musik Akademie', place: m[1].trim() };
  if (raw) return { brand: raw, place: null };
  return { brand: 'Musik Akademie', place: null };
}
